<template>
<div class='fw-time-card'>
    <div class='fw-time-card__time-wrapper'
         @click='handleClick'>
        <div class='fw-time-card__label'
             :style='{
                 backgroundColor: getColorByDistance(timeCardData.distance),
                 borderColor: getColorByDistance(timeCardData.distance)
             }'></div>
        <div v-for='time in timeCardData.dates'
             :key='time'
             class='fw-time-card__time'>
            {{ time }}
        </div>
    </div>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

type TimeCardDataType = {
    distance: number,
    dates: Array<string>
}

@Component
export default class FwTimeCard extends Vue {
    @Prop({ type: Object, required: true }) readonly timeCardData!: TimeCardDataType;

    getColorByDistance(distance: number): string {
        if (distance < 10) {
            return '#27dbbd';
        }
        if (distance < 20) {
            return '#4C5EE1';
        }
        if (distance < 40) {
            return '#C427E3';
        }
        if (distance < 70) {
            return '#E6BC16';
        }
        return '#EF103C';
    }

    handleClick(event: Event):void {
        this.$emit('click', event);
    }
}
</script>

<style lang='sass'>
.fw-time-card
    position: relative
    width: 100%
    display: flex
    padding: 5px 5px 5px 20px
    border-radius: 5px
    background-color: #fff
    overflow: hidden
    box-shadow: $base-box-shadow

    &__time-wrapper
        display: flex
        flex-flow: column nowrap
        justify-content: center
        width: 100%

    &__time
        padding: 3px 0
        width: 100%
        display: flex
        align-items: center
        justify-content: center
        font-weight: 500
        font-size: 12px

    &__label
        position: absolute
        left: 0
        top: 0
        height: 100%
        width: 7px
        border-radius: 5px 0 0 5px
        display: flex
        align-items: center
        justify-content: center

@media (max-height: 800px)
    .fw-time-card
        &__time
            font-size: 10px
</style>
